import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Visibility } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { IconButton, Typography, MenuItem, MenuList } from '@material-ui/core'

import Menus from 'app/componentV4/Menu/Menus'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'
import Circular from 'app/componentV4/Loader/Circular'

import useViewInAction from './useViewInAction'

const useStyles = makeStyles((theme) => ({
  tooltip: {
    fontWeight: 'bolder',
    fontSize: '10px',
  },
  menus: {
    '& .MuiPaper-root': {
      padding: 0,
      width: '220px',
      maxHeight: '245px',
      overflow: 'scroll',
      borderRadius: '4px',
      '& .MuiMenu-list': {
        padding: '0',
      },
    },
    '& .view-in-header': {
      backgroundColor: theme.colors.white,
      color: theme.colors['primary'],
      padding: '1rem',
      position: 'fixed',
      fontSize: '14px',
      fontWeight: 400,
      width: '220px',
      borderRadius: '4px 4px 0 0',
      zIndex: 9999,
    },
    '& .view-in-item': {
      color: theme.colors['primary'],
      padding: '1rem',
      cursor: 'pointer',
      display: 'flex',
      fontSize: '14px',
      fontWeight: 400,
      justifyContent: 'space-between',
      '&:hover': {
        backgroundColor: theme.colors['primary-200'],
      },
    },
  },
}))

const ViewInAction = (props) => {
  const { id, onFetchDetailLanguage } = props
  const { formatMessage } = useIntl()
  const classes = useStyles()

  const {
    state: { isLoading, translationLanguage },
    fetchTranslationLanguage,
  } = useViewInAction(id)

  const [anchorEl, setAnchorEl] = useState(null)

  const openMenu = (event) => {
    fetchTranslationLanguage()
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  function closeMenu(event) {
    event.stopPropagation()
    setAnchorEl(null)
  }
  return (
    <>
      <PrimaryTooltip
        title={formatMessage({
          id: 'notificationTimeline.card.viewInLanguage',
        })}
      >
        <IconButton
          className="text-primary"
          aria-owns={anchorEl ? 'view-in-list' : null}
          aria-haspopup="true"
          size="small"
          onClick={openMenu}
        >
          <Visibility fontSize="small" />
        </IconButton>
      </PrimaryTooltip>

      <Menus
        id="view-in-list"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        className={classes.menus}
      >
        <MenuList className="view-in-header border-b border-primary-350">
          {formatMessage({ id: 'notificationTimeline.card.viewInLanguage' })}
        </MenuList>
        {isLoading ? (
          <div className="flex justify-center pt-48">
            <Circular color="secondary" size={12} className="my-10" />
          </div>
        ) : (
          <div className="pt-48">
            {translationLanguage.map((language) => (
              <MenuItem
                key={`${language.id}-lang`}
                className="view-in-item"
                disabled={!language.isTranslated}
                onClick={(event) => {
                  onFetchDetailLanguage({
                    languageId: language.id,
                    notificationId: id,
                  })
                  closeMenu(event)
                }}
              >
                <div>
                  <Typography className="text-12">{language.name}</Typography>
                  <Typography className="text-12">
                    {language.nativeName}
                  </Typography>
                </div>
                <Typography
                  className={!language.isTranslated ? 'text-20' : 'text-12'}
                >
                  {!language.isTranslated ? '-' : language.subscriberCount}
                </Typography>
              </MenuItem>
            ))}
          </div>
        )}
      </Menus>
    </>
  )
}

ViewInAction.propTypes = {
  id: PropTypes.number,
  onFetchDetailLanguage: PropTypes.func,
}
export default ViewInAction
